<header data-component="header" class="row" data-module="header" data-view="navigation">
  <section class="container">
    <article class="row">
      <div class="col-6 col-md-3 no-padding signon_partner_logo"
        *ngIf="'THD' === branding?.cmcomponent$$cmpnt_svc_cw_branding_primary?.BUSINESS_ID || 'OS' === branding?.cmcomponent$$cmpnt_svc_cw_branding_primary?.BUSINESS_ID || 'DL' === branding?.cmcomponent$$cmpnt_svc_cw_branding_primary?.BUSINESS_ID; else noSpeedbump">
        <a (click)="clickAction($event)" svcSpeedBump href="{{branding?.cmlink$$link_go_to_partner_site?.URL.FULL_URL}}" target="_blank">
          <div class="partnerLogo" role="img" [attr.aria-label]="partnerLogoAda">
          </div>
        </a>
      </div>
      <ng-template #noSpeedbump>
        <div class="col-6 col-md-3 no-padding signon_partner_logo"> 
          <div class="partnerLogo" role="img" [attr.aria-label]="partnerLogoAda">
          </div>
        </div>
      </ng-template>

      <div class="col-6 col-md-9 no-padding " >
     
      <div class="signon_partner_link" *ngIf="isBestBuy">
        <a href="{{pageData?.copy$$signon_partner_link?.LINK}}" data-role="none" (click)="clickAction_link($event)" [innerHTML]="pageData?.copy$$signon_partner_link?.TEXT"></a>
      </div>
      <div class="signon_partner_link" *ngIf="isSear">
        <div class="signon_partner_link_sears">
          <a class="headerLink" (click)="clickAction_link($event)" href="{{pageData?.copy$$signon_partner_link?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$signon_partner_link?.TEXT"></a>
          <a class="headerLink" (click)="clickAction_link($event)" href="{{pageData?.copy$$store_locator?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$store_locator?.TEXT"></a>
          <a class="headerLink" (click)="clickAction_link($event)" href="{{pageData?.copy$$local_ad?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$local_ad?.TEXT"></a>
        </div>
      </div>

      <div class="signon_partner_link" *ngIf="isSyw">
        <a href="{{pageData?.copy$$signon_partner_link?.LINK}}" data-role="none" (click)="clickAction_link($event)" [innerHTML]="pageData?.copy$$signon_partner_link?.TEXT"></a>
      </div>
 
      <div class="signon_partner_link" *ngIf="isSunoco">
        <div class="signon_partner_link_sunoco">
          <a class="headerLink" (click)="clickAction_link($event)"  href="{{pageData?.copy$$signon_partner_link?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$signon_partner_link?.TEXT"></a>
        </div>
      
      </div>
      <div class="signon_partner_link" *ngIf="isThd">
        <div class="signon_partner_link">
          <a class="return_to_home" (click)="clickAction_link($event)" href="{{pageData?.copy$$signon_partner_link?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$signon_partner_link?.TEXT"></a>
          <span class="float-right pipeClass">&#160;|&#160;</span>
          <a class="headerLink" (click)="clickAction_link($event)" href="{{pageData?.copy$$special_offer_link?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$special_offer_link?.TEXT"></a>
          <span class="float-right pipeClass">&#160;|&#160;</span>
          <a class="headerLink" (click)="clickAction_link($event)" href="{{pageData?.copy$$credit_center?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$credit_center?.TEXT"></a>
          <span class="float-right pipeClass">&#160;|&#160;</span>
          <a class="headerLink" (click)="clickAction_link($event)" href="{{pageData?.copy$$store_finder?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$store_finder?.TEXT"></a>
          <span class="float-right pipeClass">&#160;|&#160;</span>
          <a class="headerLink" (click)="clickAction_link($event)" href="{{pageData?.copy$$local_ad?.LINK}}" [innerHTML]="pageData?.copy$$local_ad?.TEXT"
            data-role="none"></a>
        </div>
      </div>
      <div class="signon_partner_link" *ngIf="isThdca">
        <div class="signon_partner_link">
          <span class="float-right pipeClass">&#160;|&#160;</span>
          <a class="headerLink" (click)="clickAction_link($event)" href="{{pageData?.copy$$signon_partner_link?.LINK}}" data-role="none" [innerHTML]="pageData?.copy$$signon_partner_link?.TEXT"></a>
          <span class="float-right pipeClass">&#160;|&#160;</span>
          <a class="headerLink" (click)="clickAction_link($event)"
            href="{{pageData?.copy$$store_finder_link?.LINK}}"
            data-role="none" [innerHTML]="pageData?.copy$$store_finder_link?.TEXT"></a> 
            <span class="float-right pipeClass">&#160;|&#160;</span> 
            <a class="headerLink" (click)="clickAction_link($event)"
            href="{{pageData?.copy$$weekly_flyer_link?.LINK}}" data-role="none"  [innerHTML]="pageData?.copy$$weekly_flyer_link?.TEXT"></a>
        </div>
      </div>
      </div>
    </article>
  </section>
</header>
